import {
  Button,
  Card,
  Drawer,
  Icon,
  Tag,
  Select,
  notification, Popconfirm
} from 'antd'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { TableComp } from 'sz-react-utils-lite'
import {deleteAbstractFxn,SendAbstractEmailAction,FetchAbstractEmailDataAction} from './actions'
import AbstractDrawer from "./AbstractDrawer"
import PageHeaderWrapper from '../../components/PageHeaderWrapper'
import AbstractNotesDrawer from './AbstractNotesDrawer';
import {
  DefaultTablePagination,
  DisplayDate,
  InputBox,
  ChooseEmailModal,
} from '../../components/_utils/appUtils'
import { JournalList } from '../journals/actions';
import AbstractHistoryDrawer from './AbstractHistoryDrawer';
import { getPushPathWrapper } from '../../routes'
import { listAllAbstract } from './actions'
import { chooseEmailModalFxn } from '../../components/_utils/appUtils'
const { Option } = Select;

class AllAbstract extends Component {
  constructor(props) {
    super(props)

    this.state = {
      totalAbstract: 0,
      filters: {},
      visible: false,
      selected: {},
      journalFilters: [],
      abstractDrawerVisible: false,
      selectedAbstract: null,
      otherJournalVisible: false,
      scheduleVisible: false,
      visibleAddNote: false,
      historyVisible: false,
      selectedJournal: '',
      journalsList: [],
      selectedRecord: {}
    }

    this.table = React.createRef()
  }
  componentDidMount() {
    this.loadJournalList()
  }

  loadJournalList = async () => {
    let { data } = await JournalList();
    let journals = [];
    if (data && data.length) {
      data.forEach(item => {
        journals.push({ text: item.name, value: item.name });
      });
    }
    this.setState({ journalsList: journals });
  }
  apiRequest = (params) => {
    return new Promise(async (resolve) => {
      try {
        let status = params.status || { $ne: 'Processed' };
        let filters = {
          ...params,
          status: status,
          sortField: params.sortField || '_id',
          sortOrder: params.sortOrder ? Number(params.sortOrder) : -1,

          regExFilters: [
            'titleOfAbstract',
            'authorName',
            'email',
            'country',
            'researchArea',
            'institution'
          ]
        }
        if (params.journals) {
          filters.journals = params.journals
        }

        let data = await listAllAbstract(filters)

        this.setState({
          totalAbstract: data.total,
          filters,
          journalFilters: data.journalFilters || []
        })

        resolve(data)

      } catch (error) {
        notification.error({
          message: 'Error fetching abstracts'
        })

        resolve({ data: [], total: 0 })
      }
    })
  }
  reload = () => {
    this.table.current.reload()
  }
  showOtherJournalDrawer = (record) => {
    this.setState({
      otherJournalVisible: true,
      selectedRecordId: record._id,
      selectedRecordData: record,
      selectedJournal: record.journals
    })
  }
  openDrawer = (record) => {
    this.setState({
      visible: true,
      selected: record,
      abstractDrawerVisible: true,
      selectedAbstract: record
    })
  }
  deleteAbstract = async (record) => {
    try {
      let resp = await deleteAbstractFxn(record._id)

      if (resp && resp.success) {
        notification.success({
          message: 'Deleted successfully'
        })

        this.reload()
      } else {
        notification.error({
          message: resp.message || 'Delete failed'
        })
      }

    } catch (error) {
      notification.error({
        message: 'Server error while deleting'
      })
    }
  }
  handleOtherJournalSubmit = (email) => {
    const { dispatch } = this.props;
    const { selectedRecordId, selectedJournal, selectedRecordData } = this.state;

    if (!selectedJournal) {
      return notification.warning({ message: "Please select a journal" });
    }

    let obj = {
      type: 'abstract',
      status: 'Another Journal',
      countryName: selectedRecordData.country,
      fromEmail: email,
      template: 'anotherJournal',
      anotherJournalName: selectedJournal
    };

    dispatch(SendAbstractEmailAction({ id: selectedRecordId, obj })).then(resp => {
      if (resp && resp.success) {
        notification.success({ message: 'Success', description: 'Abstract moved successfully' });
        this.setState({ otherJournalVisible: false });
        this.reload();
      }
    });
  };
  chooseMailFxnEvent = async (id, template, status) => {
    const { dispatch } = this.props;
    let response = await dispatch(FetchAbstractEmailDataAction(id));

    if (response && response.success) {
      const abstractData = response.data;

      chooseEmailModalFxn({
        title: status,
        data: abstractData, // Pass the fetched data to the modal for placeholders
        callback: async (email) => {
          let obj = {
            type: 'abstract',
            status,
            countryName: abstractData.country,
            fromEmail: email,
            template: template
          };
          let resp = await dispatch(SendAbstractEmailAction({ id, obj }));

          if (resp && resp.success) {
            notification.success({
              message: 'Success',
              description: `Email sent and status updated to ${status}`
            });
            this.reload();
          }
        }
      });
    }
  };
  // showScheduleDrawer = (record) => {
  //   this.setState({
  //     scheduleVisible: true,
  //     selectedRecordId: record._id,
  //     selectedRecordData: record,
  //     selectedJournal: record.journal
  //   })
  // }
  showScheduleDrawer = (record) => {
    this.setState({
      scheduleVisible: true,
      selectedRecordId: record._id,
      selectedRecordData: record,
      selectedJournal: record.journal
        ? (typeof record.journal === 'object' ? record.journal.name : record.journal)
        : ''
    });
  }
  onCloseAddNote = () => {
    this.setState({ visibleAddNote: false });
    this.reload();
  }
  handleScheduleSubmit = (email) => {
    const { dispatch } = this.props;
    const { selectedRecordId, selectedJournal, selectedRecordData } = this.state;

    let obj = {
      type: 'abstract',
      status: 'Schedule',
      countryName: selectedRecordData.country,
      fromEmail: email,
      template: 'schedule',
      anotherJournalName: selectedJournal
    };

    dispatch(SendAbstractEmailAction({ id: selectedRecordId, obj })).then(resp => {
      if (resp && resp.success) {
        notification.success({ message: 'Success', description: 'Abstract scheduled successfully' });
        this.setState({ scheduleVisible: false });
        this.reload();
      }
    });
  };  render() {

    const { selected } = this.state

    const columns = [
      {
        title: 'ID',
        dataIndex: 'abstractId',
        width: 80,
        searchTextName: 'abstractId',
        render: (id) => id || 'N/A'
      },
      {
        title: 'Date',
        dataIndex: 'createdAt',
        width: 120,
        render: (d) => DisplayDate(d)
      },
      // {
      //   title: 'Journal',
      //   dataIndex: 'journal',
      //   width: 200,
      //   filters: this.state.journalFilters,
      //   filterMultiple: true,
      // },
      {
        title: 'Journal',
        dataIndex: 'journal',
        width: 200,
        render: (journal) => {
          if (!journal) return "N/A";
          if (typeof journal === 'object') {
            return journal.name || journal.journalName || "Unnamed Journal";
          }
          return journal;
        },
        filters: this.state.journalFilters,
        filterMultiple: true,
      },
      {
        title: 'Title',
        dataIndex: 'titleOfAbstract',
        width: 250,
        searchTextName: 'titleOfAbstract',
        render: (t, r) => (
          <a onClick={() => this.openDrawer(r)}>
            {t}
          </a>
        )
      },
      {
        title: 'Author',
        dataIndex: 'authorName',
        width: 160,
        searchTextName: 'authorName'
      },
      {
        title: 'Designation',
        dataIndex: 'designation',
        width: 150,
        searchTextName: 'designation'
      },
      {
        title: 'Institution',
        dataIndex: 'institution',
        width: 150,
        searchTextName: 'institution'
      },
      {
        title: 'Email',
        dataIndex: 'email',
        width: 200,
        searchTextName: 'email'
      },
      {
        title: 'Mobile',
        dataIndex: 'mobile',
        width: 120,
        searchTextName: 'mobile'
      },
      // {
      //   title: 'Country',
      //   dataIndex: 'country',
      //   width: 90,
      //   searchTextName: 'country'
      // },
      {
        title: 'Research Area',
        dataIndex: 'researchArea',
        width: 110,
        searchTextName: 'researchArea'
      },
      {
        title: 'Status',
        dataIndex: 'status',
        width: 110,
        align: 'center',
        render: (status) => (
          <Tag color={
            status === 'Submitted Abstract' ? 'orange' :
              status === 'Processed' ? 'green' :
                'blue'
          }>
            {status || 'N/A'}
          </Tag>
        )
      },
      // {
      //   title: 'Issue Type',
      //   dataIndex: 'issueType',
      //   width: 120,
      //   searchTextName: 'IssueType'
      // },
      {
        title: 'Actions',
        key: 'actions',
        width: 220,
        render: (text, record) => {
          return (
            <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap', justifyContent: 'flex-start' }}>
              <Button
                className="roundSmallBtn2"
                onClick={() => {
                  this.props.dispatch(
                    getPushPathWrapper('onlineAbstractsGroup.onlineSubmission', {
                      id: record._id
                    })
                  )
                }}
              >
                Proceed
              </Button>
              <Button
                className="roundSmallBtn2"
                onClick={() => this.chooseMailFxnEvent(record._id, 'notFit', 'Not Fit', record)}
              >
                Not Fit
              </Button>
              <Button
                className="roundSmallBtn2"
                onClick={() => this.showOtherJournalDrawer(record)}
              >
                Other Journals
              </Button>
              <Button
                className="roundSmallBtn2"
                onClick={() => this.showScheduleDrawer(record)}
              >
                Schedule
              </Button>
              <Button
                className="roundSmallBtn2"
                onClick={() => this.chooseMailFxnEvent(record._id, 'asPerFormat', 'As per format', record)}
              >
                As per format
              </Button>
              <Button
                className="roundSmallBtn2"
                onClick={() => this.chooseMailFxnEvent(record._id, 'withdraw', 'Withdraw', record)}
              >
                Withdraw
              </Button>
              <Popconfirm
                placement="topLeft"
                title={`Are you sure you want to delete this abstract?`}
                onConfirm={() => this.deleteAbstract(record)}
                okText="Yes"
                cancelText="No"
              >
                <Button className="roundSmallBtn2">
                  Delete
                </Button>
              </Popconfirm>
              <Button
                className="roundSmallBtn2"
                onClick={() => {
                  this.setState({
                    visibleAddNote: true,
                    selectedRecordId: record._id
                  })
                }}
              >
                <Icon type={'plus'} />
                Notes ({record.notes ? record.notes.length : 0})
              </Button>
              <Button
                className="roundSmallBtn2"
                onClick={() => {
                  this.setState({
                    historyVisible: true,
                    selectedRecordId: record._id
                  })
                }}
              >
                History
              </Button>

            </div>
          )
        }
      }
    ]

    return (
      <PageHeaderWrapper title={`Online Abstract (${this.state.totalAbstract})`}>

        <Card>
          <TableComp
            ref={this.table}
            columns={columns}
            apiRequest={this.apiRequest}
            pagination={DefaultTablePagination({}, 50)}
            extraProps={{ scroll: { x: 1000 } }}
          />
        </Card>
        {this.state.abstractDrawerVisible && (
          <AbstractDrawer
            visible={this.state.abstractDrawerVisible}
            data={this.state.selectedAbstract}
            callBackReload={() => this.reload()}
            onClose={() => this.setState({
              abstractDrawerVisible: false,
              selectedAbstract: null,
              visible: false,
              selected: {}
            })}
          />
        )}
        {/*<Drawer*/}
        {/*  title={*/}
        {/*    <p>*/}
        {/*      Choose Another Journal*/}
        {/*      <br />*/}
        {/*      <br />*/}
        {/*      <h3>*/}
        {/*        {this.state.selectedRecordData && this.state.selectedRecordData.journals} (*/}
        {/*        {this.state.selectedRecordData && this.state.selectedRecordData.authorName})*/}
        {/*      </h3>*/}
        {/*    </p>*/}
        {/*  }*/}
        {/*  width={500}*/}
        {/*  onClose={() => this.setState({ otherJournalVisible: false })}*/}
        {/*  visible={this.state.otherJournalVisible}*/}
        {/*  bodyStyle={{ paddingBottom: 80 }}*/}
        {/*  footer={*/}
        {/*    <div className={'alignRight'}>*/}
        {/*      <Button onClick={() => this.setState({ otherJournalVisible: false })} style={{ marginRight: 8 }}>*/}
        {/*        Cancel*/}
        {/*      </Button>*/}
        {/*    </div>*/}
        {/*  }*/}
        {/*>*/}
        {/*  <Card>*/}
        {/*    <InputBox title={'Select Journal'}>*/}
        {/*      <Select*/}
        {/*        style={{ width: '100%' }}*/}
        {/*        onChange={val => this.setState({ selectedJournal: val })}*/}
        {/*        value={this.state.selectedJournal}*/}
        {/*      >*/}
        {/*        {this.state.journalsList && this.state.journalsList.length*/}
        {/*          ? this.state.journalsList.map((item, key) => (*/}
        {/*            <Option key={key} value={item.value}>*/}
        {/*              {item.text}*/}
        {/*            </Option>*/}
        {/*          ))*/}
        {/*          : null}*/}
        {/*      </Select>*/}
        {/*    </InputBox>*/}

        {/*    <br />*/}
        {/*    <Button*/}
        {/*      className={'linkIcon'}*/}
        {/*      onClick={() => {*/}
        {/*        // 1. Check if a journal is selected before opening the modal*/}
        {/*        if (!this.state.selectedJournal) {*/}
        {/*          return notification.warning({ message: "Please select a journal first" });*/}
        {/*        }*/}

        {/*        chooseEmailModalFxn({*/}
        {/*          title: 'Another Journal',*/}
        {/*          callback: (email) => {*/}
        {/*            this.handleOtherJournalSubmit(email);*/}
        {/*          }*/}
        {/*        });*/}
        {/*      }}*/}
        {/*    >*/}
        {/*      Submit*/}
        {/*    </Button>*/}
        {/*  </Card>*/}
        {/*</Drawer>*/}
        {/*/!* SCHEDULE DRAWER IMPLEMENTATION *!/*/}
        {/*<Drawer*/}
        {/*  title={*/}
        {/*    <p>*/}
        {/*      Schedule Abstract*/}
        {/*      <br />*/}
        {/*      <br />*/}
        {/*      <h3>*/}
        {/*        {this.state.selectedRecordData &&*/}
        {/*          (typeof this.state.selectedRecordData.journal === 'object'*/}
        {/*            ? this.state.selectedRecordData.journal.name*/}
        {/*            : this.state.selectedRecordData.journal)}*/}
        {/*        ({this.state.selectedRecordData && this.state.selectedRecordData.authorName})*/}
        {/*      </h3>*/}
        {/*    </p>*/}
        {/*  }*/}
        {/*  width={500}*/}
        {/*  onClose={() => this.setState({ scheduleVisible: false })}*/}
        {/*  visible={this.state.scheduleVisible}*/}
        {/*  bodyStyle={{ paddingBottom: 80 }}*/}
        {/*  footer={*/}
        {/*    <div className={'alignRight'}>*/}
        {/*      <Button onClick={() => this.setState({ scheduleVisible: false })} style={{ marginRight: 8 }}>*/}
        {/*        Cancel*/}
        {/*      </Button>*/}
        {/*    </div>*/}
        {/*  }*/}
        {/*>*/}
        {/*  <Card>*/}
        {/*    <InputBox title={'Confirm Journal'}>*/}
        {/*      <Select*/}
        {/*        style={{ width: '100%' }}*/}
        {/*        onChange={val => this.setState({ selectedJournal: val })}*/}
        {/*        value={this.state.selectedJournal}*/}
        {/*      >*/}
        {/*        {this.state.journalsList && this.state.journalsList.length*/}
        {/*          ? this.state.journalsList.map((item, key) => (*/}
        {/*            <Option key={key} value={item.value}>*/}
        {/*              {item.text}*/}
        {/*            </Option>*/}
        {/*          ))*/}
        {/*          : null}*/}
        {/*      </Select>*/}
        {/*    </InputBox>*/}

        {/*    <br />*/}
        {/*    <Button*/}
        {/*      className={'linkIcon'}*/}
        {/*      onClick={() => {*/}
        {/*        if (!this.state.selectedJournal) {*/}
        {/*          return notification.warning({ message: "Please select a journal first" });*/}
        {/*        }*/}

        {/*        chooseEmailModalFxn({*/}
        {/*          title: 'Schedule Abstract',*/}
        {/*          callback: (email) => {*/}
        {/*            this.handleScheduleSubmit(email);*/}
        {/*          }*/}
        {/*        });*/}
        {/*      }}*/}
        {/*    >*/}
        {/*      Submit*/}
        {/*    </Button>*/}
        {/*  </Card>*/}
        {/*</Drawer>*/}
        <Drawer
          title={
            <p>
              Choose Another Journal
              <br />
              <br />
              <h3>
                {this.state.selectedRecordData && this.state.selectedRecordData.journal ? (
                  typeof this.state.selectedRecordData.journal === 'object'
                    ? (this.state.selectedRecordData.journal.name || "Unnamed Journal")
                    : this.state.selectedRecordData.journal
                ) : (
                  "No Journal Assigned"
                )}
                {this.state.selectedRecordData && this.state.selectedRecordData.authorName && (
                  ` (${this.state.selectedRecordData.authorName})`
                )}
              </h3>
            </p>
          }
          width={500}
          onClose={() => this.setState({ otherJournalVisible: false })}
          visible={this.state.otherJournalVisible}
          bodyStyle={{ paddingBottom: 80 }}
          footer={
            <div className={'alignRight'}>
              <Button onClick={() => this.setState({ otherJournalVisible: false })} style={{ marginRight: 8 }}>
                Cancel
              </Button>
            </div>
          }
        >
          <Card>
            <InputBox title={'Select Journal'}>
              <Select
                style={{ width: '100%' }}
                onChange={val => this.setState({ selectedJournal: val })}
                value={this.state.selectedJournal}
              >
                {this.state.journalsList && this.state.journalsList.length
                  ? this.state.journalsList.map((item, key) => (
                    <Option key={key} value={item.value}>
                      {item.text}
                    </Option>
                  ))
                  : null}
              </Select>
            </InputBox>

            <br />
            <Button
              className={'linkIcon'}
              onClick={() => {
                if (!this.state.selectedJournal) {
                  return notification.warning({ message: "Please select a journal first" });
                }

                chooseEmailModalFxn({
                  title: 'Another Journal',
                  callback: (email) => {
                    this.handleOtherJournalSubmit(email);
                  }
                });
              }}
            >
              Submit
            </Button>
          </Card>
        </Drawer>

        {/* SCHEDULE DRAWER IMPLEMENTATION */}
        <Drawer
          title={
            <p>
              Schedule Abstract
              <br />
              <br />
              <h3>
                {this.state.selectedRecordData && this.state.selectedRecordData.journal ? (
                  typeof this.state.selectedRecordData.journal === 'object'
                    ? (this.state.selectedRecordData.journal.name || "Unnamed Journal")
                    : this.state.selectedRecordData.journal
                ) : (
                  "No Journal Assigned"
                )}
                {this.state.selectedRecordData && this.state.selectedRecordData.authorName && (
                  ` (${this.state.selectedRecordData.authorName})`
                )}
              </h3>
            </p>
          }
          width={500}
          onClose={() => this.setState({ scheduleVisible: false })}
          visible={this.state.scheduleVisible}
          bodyStyle={{ paddingBottom: 80 }}
          footer={
            <div className={'alignRight'}>
              <Button onClick={() => this.setState({ scheduleVisible: false })} style={{ marginRight: 8 }}>
                Cancel
              </Button>
            </div>
          }
        >
          <Card>
            <InputBox title={'Confirm Journal'}>
              <Select
                style={{ width: '100%' }}
                onChange={val => this.setState({ selectedJournal: val })}
                value={this.state.selectedJournal}
              >
                {this.state.journalsList && this.state.journalsList.length
                  ? this.state.journalsList.map((item, key) => (
                    <Option key={key} value={item.value}>
                      {item.text}
                    </Option>
                  ))
                  : null}
              </Select>
            </InputBox>

            <br />
            <Button
              className={'linkIcon'}
              onClick={() => {
                if (!this.state.selectedJournal) {
                  return notification.warning({ message: "Please select a journal first" });
                }

                chooseEmailModalFxn({
                  title: 'Schedule Abstract',
                  callback: (email) => {
                    this.handleScheduleSubmit(email);
                  }
                });
              }}
            >
              Submit
            </Button>
          </Card>
        </Drawer>
        {this.state.visibleAddNote && (
          <AbstractNotesDrawer
            visible={this.state.visibleAddNote}
            abstractId={this.state.selectedRecordId}
            onClose={() => this.onCloseAddNote()}
          />
        )}
        <AbstractHistoryDrawer
          visible={this.state.historyVisible}
          abstractId={this.state.selectedRecordId}
          onClose={() => this.setState({ historyVisible: false, selectedRecordId: null })}
        />
      </PageHeaderWrapper>
    )
  }
}

export default connect()(AllAbstract)
